var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    d: "M0 0h20v14H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h6.667v14H0V0z",
    fill: "#249F58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 9.333c1.578 0 2.857-1.253 2.857-2.8 0-1.546-1.28-2.8-2.857-2.8-1.578 0-2.857 1.254-2.857 2.8 0 1.547 1.279 2.8 2.857 2.8z",
    fill: "#FFDA2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.571 7.467v-2.8h-3.81v2.8c0 .515.853.933 1.906.933 1.052 0 1.904-.418 1.904-.933z",
    fill: "#F93939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.714 5.6H7.62v1.867H5.714V5.6z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.714 5.6h.953v.933h-.953V5.6zm.953.933h.952v.934h-.952v-.934z",
    fill: "#1A47B8"
  })));
}
export default SvgPt;